export const getFetchStatus = (state) => state.searchAiSummary.fetchStatus;
export const getSearchAiSummaryText = (state) => state.searchAiSummary.searchAiSummary?.text;
